import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type PromotionShop = {
  promotion_shop_id?: number; // 프로모션 참여업체 idx
  promotion_id?: number; // 프로모션 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  application_status?: string; // 신청 상태
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] PromotionShop
   * --
   */
  getPromotionShops: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PROMOTION_SHOP, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] PromotionShop
   * --
   */
  getPromotionShop: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PROMOTION_SHOP, {
        promotion_shop_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] PromotionShop
   * --
   */
  createPromotionShop: async (body: PromotionShop) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PROMOTION_SHOP, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] PromotionShop
   * --
   */
  updatePromotionShop: async (body: PromotionShop) => {
    try {
      const { promotion_shop_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PROMOTION_SHOP, {
        promotion_shop_id: promotion_shop_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] PromotionShop
   * --
   */
  deletePromotionShop: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PROMOTION_SHOP, {
        promotion_shop_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
